const postal = require("postal")

window.postalLib = postal